import { z } from 'zod'

export const paypalOneClickShippingMethodSchema = z.object({
  shippingMethod: z
    .string({
      required_error: 'This is a required field.',
    })
    .min(1, 'This is a required field.'),
  agreementCheckbox: z
    .boolean()
    .refine((val) => val === true, {
      message: 'This is a required field.',
    })
    .optional()
    .default(false),
})
